<template>
  <div class="controltextstyle">
    <h5 class="font-bold-24" v-if="displayForUsers">Available Users</h5>
    <h5 v-if="!displayForUsers"></h5>
    <div class="utils">
      <el-input
        id="usersearch"
        v-model="usrSearchVal"
        placeholder="Search"
        type="search"
        :debounce="1000"
        class="rightmargin inpstyle"
        v-if="showOptions"
      >
        <template #suffix>
          <img
            src="@/assets/icons/search.svg"
            style="width: 25px"
            alt="searchimg"
            title="searchimg"
          />
        </template>
      </el-input>
      <el-button
        plain
        class="delbtn"
        @click="addUserHandler"
        v-if="displayForUsers"
        id="addUser"
      >
        <img
          src="@/assets/icons/adduser.svg"
          style="width: 40px"
          alt="adduserimage"
          title="Add User"
        />
      </el-button>
      <el-button
        plain
        class="delbtn"
        @click="showAddProducts"
        v-if="!displayForUsers"
        id="assignproduct"
        :disabled="!enablebuttons"
      >
        <img
          src="@/assets/icons/add.svg"
          style="width: 40px"
          v-if="enablebuttons"
          alt="addproductimage"
          title="Add Product"
        />
        <img
          src="@/assets/icons/adddisabled.svg"
          style="width: 40px"
          v-if="!enablebuttons"
          alt="addproductdisabledimage"
          title="Add Product"
        />
      </el-button>
      <el-button
        plain
        class="delbtn"
        @click="assignAddon"
        id="addignaddon"
        v-if="showOptions && !disableAssignAddon"
        :disabled="!enablebuttons"
      >
        <img
          src="@/assets/icons/addaddonenabled.svg"
          style="width: 40px"
          v-if="enablebuttons && !disableAssignAddon"
          alt="addaddonenabledimage"
          title="Assign Add-on"
        />
        <img
          src="@/assets/icons/addaddondisabled.svg"
          style="width: 40px"
          v-if="!enablebuttons"
          alt="addaddondisabledimage"
          title="Assign Add-on"
        />
      </el-button>
      <el-tooltip
        class="box-item"
        effect="dark"
        placement="top"
        v-if="showOptions && disableAssignAddon"
      >
        <template #content>
          Some selected users do not have any or common <br />products assigned
          .
        </template>
        <el-button
          plain
          class="delbtn"
          id="addignaddondisabled"
          :disabled="disableAssignAddon"
        >
          <img
            src="@/assets/icons/addontooltipwarn.svg"
            style="width: 40px"
            alt="addonrestrictedImage"
          />
        </el-button>
      </el-tooltip>

      <el-button
        plain
        class="delbtn"
        @click="removeAddon"
        id="removeaddon"
        v-if="showOptions"
        :disabled="!enablebuttons && DisableDeleteAddon"
      >
        <img
          src="@/assets/icons/deladdonenabled.svg"
          style="width: 40px"
          v-if="enablebuttons && !DisableDeleteAddon"
          alt="deladdonenabledimage"
          title="Remove Add-on"
        />
        <img
          src="@/assets/icons/deladdondisabled.svg"
          style="width: 40px"
          v-if="enablebuttons && DisableDeleteAddon"
          alt="deladdondisabledimage"
          title="Remove Add-on"
        />
        <img
          src="@/assets/icons/deladdondisabled.svg"
          style="width: 40px"
          v-if="!enablebuttons"
          alt="deladdondisabledimage"
          title="Remove Add-on"
        />
      </el-button>
      <el-button
        plain
        class="delbtn"
        @click="showDeleteDailogue = true"
        id="deleteuser"
        v-if="showOptions && !disableDelete"
        :disabled="!enablebuttons"
      >
        <img
          src="@/assets/icons/delete.svg"
          style="width: 40px"
          v-if="enablebuttons"
          alt="deleteuserimage"
          title="Delete User"
        />
        <img
          src="@/assets/icons/deletedisabled.svg"
          style="width: 40px"
          v-if="!enablebuttons"
          alt="deletedisabledimage"
          title="Delete User"
        />
      </el-button>
      <el-tooltip
        class="box-item"
        effect="dark"
        placement="top"
        v-if="showOptions && disableDelete"
      >
        <template #content>
          Some selected users have borrowed licenses.
        </template>
        <el-button
          plain
          class="delbtn"
          id="deleteUserWarn"
          :disabled="disableAssignAddon"
        >
          <img
            src="@/assets/icons/deletedisabledwarning.svg"
            style="width: 40px"
            alt="deletedisabledimage"
            title="Delete User"
          />
        </el-button>
      </el-tooltip>
    </div>
  </div>
  <el-dialog
    title="Delete Users"
    v-model="showDeleteDailogue"
    width="35%"
    top="25vh"
    center
  >
    <el-divider></el-divider>
    <div class="text-div font-regular-16">
      <span
        ><strong>{{ usersSelectedCount }}</strong> Users selected
      </span>
      <br />
      <span>All user data and licenses will be permanently removed.</span>
      <span>This action may not be undone.</span>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          id="deleteusercancel"
          @click="showDeleteDailogue = false"
          round
          class="cancelbtn"
          variant="outline-dark"
          >Cancel</el-button
        >
        <el-button
          type="danger"
          @click="deleteUser"
          round
          class="deletebutton"
          id="deleteuserconfirm"
        >
          Confirm
        </el-button>
      </span>
    </template>
  </el-dialog>
  <el-drawer
    v-model="showAddprod"
    direction="rtl"
    size="40%"
    destroy-on-close
    :before-close="closeModal"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :wrapperClosable="false"
  >
    <AssignProductsModal />
  </el-drawer>
  <el-drawer
    v-model="showAdduser"
    direction="rtl"
    size="40%"
    destroy-on-close
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="closeModal"
  >
    <AddUserModal />
  </el-drawer>
  <el-drawer
    v-model="showRemoveAddon"
    direction="rtl"
    size="40%"
    destroy-on-close
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="closeModal"
  >
    <RemoveAddonsModal />
  </el-drawer>
  <el-drawer
    v-model="showAssignAddon"
    direction="rtl"
    size="40%"
    destroy-on-close
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :wrapperClosable="false"
    :before-close="closeModal"
  >
    <AssignMultipleAddonsModal :intersectionList="productsIntersectionList" />
  </el-drawer>
</template>

<style lang="scss"></style>
<script lang="ts">
import { defineComponent } from "vue";
import { ElMessage } from "element-plus";
import APIService from "@/utils/APIService";
import AddUserModal from "@/components/AddUserModal.vue";
import AssignProductsModal from "@/components/AssignProductsModal.vue";
import AssignMultipleAddonsModal from "./AssignMultipleAddonsModal.vue";
import RemoveAddonsModal from "./RemoveAddonsModal.vue";
import { mapGetters } from "vuex";
import _ from "lodash";
import { FlowActionTypes } from "@/store/flowstore/FlowActionTypes";
import { UserActionTypes } from "@/store/userstore/UserActionTypes";
import { ProductActionTypes } from "@/store/productstore/ProductActionTypes";
import { AuthActionTypes } from "@/store/authstore/AuthActionTypes";
import { CompanyActionTypes } from "@/store/companystore/CompanyActionTypes";

export default defineComponent({
  name: "UserOptions",
  components: {
    AddUserModal,
    AssignProductsModal,
    AssignMultipleAddonsModal,
    RemoveAddonsModal,
  },
  computed: {
    ...mapGetters([
      "getUsersList",
      "getShowAdduser",
      "getCurrentUser",
      "getSlectedEmails",
      "getCurrentPage",
      "getSearchValue",
      "getAddonUsers",
      "getSelectedUsers",
      "getShowAssignAddon",
      "getShowRemoveAddon",
      "getCompanyData",
      "getShowAddProducts",
    ]),
    currentPage(): number {
      return this.getCurrentPage;
    },
    currentUserRole(): string {
      return _.isEmpty(this.getCurrentUser)
        ? ""
        : this.getCurrentUser.result.currentrole;
    },
    showAdduser: {
      get(): boolean {
        return this.getShowAdduser;
      },
      set() {
        this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDUSER, false);
      },
    },
    showAddprod: {
      get(): any {
        return this.getShowAddProducts;
      },
      set() {
        this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDPRODUCTS, false);
      },
    },
    showAssignAddon: {
      get(): boolean {
        return this.getShowAssignAddon;
      },
      set() {
        this.$store.dispatch(FlowActionTypes.SET_SHOW_ASSIGNADDON, false);
      },
    },
    showRemoveAddon: {
      get(): boolean {
        return this.getShowRemoveAddon;
      },
      set() {
        this.$store.dispatch(FlowActionTypes.SET_SHOW_REMOVEADDON, false);
      },
    },
    usrSearchVal: {
      get(): string {
        return this.getSearchValue === ""
          ? this.usrSearcher
          : this.getSearchValue;
      },
      set(val: string) {
        this.usrSearcher = val;
      },
    },
    showOptions(): boolean {
      return this.$route.name === "companies"
        ? true
        : !!(!_.isEmpty(this.getUsersList) || this.usrSearcher !== "");
    },
    DisableDeleteAddon(): boolean {
      return this.getAddonUsers.length === 0;
    },
    disableAssignAddon(): boolean {
      if (
        this.getSelectedUsers !== undefined &&
        this.getSelectedUsers.length !== 0
      )
        this.checkIntersectionOfProducts();

      return this.getSelectedUsers !== undefined &&
        this.getSelectedUsers.length !== 0 &&
        this.productsIntersectionList.length === 0
        ? true
        : false;
    },
    enablebuttons(): boolean {
      return this.getSlectedEmails.length !== 0;
    },
    usersSelectedCount(): number {
      return this.getSlectedEmails.length || 0;
    },
    displayForUsers(): boolean {
      return this.$route.name !== "companies";
    },
  },
  data() {
    return {
      usrSearcher: "",
      showDeleteDailogue: false,
      productsIntersectionList: [] as any[],
      noProducts: false,
      disableDelete: false,
    };
  },
  watch: {
    usrSearcher(newVal) {
      const userDataObj = {
        userBucketIdList: null,
        companyBucketIdList:
          this.$route.name === "companies"
            ? [this.getCompanyData.companyBucketId]
            : null,
        searchPhrase: newVal || null,
        companyName: null,
        pageOptions: {
          skip: 0,
          take: 10,
          sortField: this.sortField,
          sortOrder: this.sortOrder,
        },
      };
      this.$store.dispatch(FlowActionTypes.SET_SEARCH_VALUE, newVal);
      this.$store.dispatch(FlowActionTypes.SET_CURRENT_PAGE, 1);
      const apiService = new APIService(this.axios);
      if (newVal.length !== 0) {
        this.checkSearchStr(userDataObj);
      } else {
        userDataObj.searchPhrase = null;
        apiService
          .getUsersList(userDataObj)
          .then((res) => {
            if (this.$route.name === "companies")
              this.$store.dispatch(UserActionTypes.SET_COMPANY_USERS, res);
            else this.$store.dispatch(UserActionTypes.SET_USERS, res);
          })
          .catch((error) => {
            if (error.code === "ECONNABORTED")
              this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
          });
      }
    },
    getSlectedEmails(newVal) {
      this.canUserBeDeleted(newVal);
    },
  },
  methods: {
    checkSearchStr: _.debounce(function (this: any, dataobject: any) {
      const apiService = new APIService(this.axios);
      apiService
        .getUsersList(dataobject)
        .then((res) => {
          if (this.$route.name === "companies")
            this.$store.dispatch(UserActionTypes.SET_COMPANY_USERS, res);
          else this.$store.dispatch(UserActionTypes.SET_USERS, res);
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    }, 1000),
    addUserHandler() {
      this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "add");
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDUSER, true);
    },
    showAddProducts() {
      this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "prodAss");
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDPRODUCTS, true);
    },
    checkIntersectionOfProducts() {
      const productsCollection: { [key: string]: any[] } = {};
      this.getSelectedUsers.map((item: any, id: number) => {
        productsCollection[`array${id}`] = item.products;
      });
      const productArray = Object.values(productsCollection);
      this.productsIntersectionList = productArray.reduce(
        (acc, currentArray) => this.arrayIntersection(acc, currentArray),
        productArray[0]
      );
    },
    arrayIntersection(arr1: any[], arr2: any[]): any[] {
      return arr1 !== undefined
        ? arr1.filter((item) =>
            arr2.some(
              (p1) =>
                p1.productBucketId === item.productBucketId &&
                p1.productName === item.productName &&
                p1.majorVersionNumber === item.majorVersionNumber &&
                p1.minorVersionNumber === item.minorVersionNumber
            )
          )
        : [];
    },
    canUserBeDeleted(selectedBucketIds: any) {
      const apiService = new APIService(this.axios);
      const userData = {
        UserBucketIdCollection: selectedBucketIds,
      };
      apiService
        .canUsersBeDeleted(userData)
        .then((res) => {
          this.disableDelete = !res.isValid;
          console.log(res);
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    },
    deleteUser() {
      const apiService = new APIService(this.axios);
      const emailData = {
        UserBucketIdCollection: this.getSlectedEmails,
      };
      apiService
        .deleteUsers(emailData)
        .then((res) => {
          const userDataObj = {
            userBucketIdList: null,
            companyBucketIdList:
              this.$route.name === "companies"
                ? [this.getCompanyData.companyBucketId]
                : null,
            searchPhrase: this.usrSearcher,
            companyName: null,
            pageOptions: {
              skip: this.currentPage - 1,
              take: 10,
              sortField: null,
              sortOrder: null,
            },
          };

          if (res.success) {
            this.updateDashboardCard();
            apiService
              .getUsersList(userDataObj)
              .then((resp) => {
                if (this.$route.name === "companies")
                  this.$store.dispatch(UserActionTypes.SET_COMPANY_USERS, resp);
                else this.$store.dispatch(UserActionTypes.SET_USERS, resp);
              })
              .catch((error) => {
                if (error.code === "ECONNABORTED")
                  this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
              });
            this.$store.dispatch(FlowActionTypes.SET_SELECTED_EMAILS, []);
            this.showDeleteDailogue = false;
            ElMessage({
              message: "User has been deleted successfully.",
              type: "success",
            });
          } else {
            ElMessage.error(res.validationResult.validationMessages[0]);
          }
        })
        .catch((error) => {
          if (error.code === "ECONNABORTED")
            this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
        });
    },
    assignAddon() {
      this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "assignmultiaddons");
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ASSIGNADDON, true);
    },
    removeAddon() {
      this.$store.dispatch(FlowActionTypes.SET_SHOW_REMOVEADDON, true);
    },
    closeModal() {
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDPRODUCTS, false);
      this.$store.dispatch(FlowActionTypes.SET_SHOW_ADDUSER, false);
      this.$store.dispatch(FlowActionTypes.SET_SELECTED_USERS, []);
      if (this.$route.name !== "product")
        this.$store.dispatch(FlowActionTypes.SET_PRODUCT_DATA, {});
      // ^ otherwise user is sent back to products overview page instead of details page
      this.$store.dispatch(FlowActionTypes.SET_TASK_TYPE, "none");
      this.$store.dispatch(ProductActionTypes.SET_AVAILABLE_PRODUCTS, {
        items: [],
      });
      this.$store.dispatch(FlowActionTypes.SET_ADDON_DATA, []);
      this.$store.dispatch(FlowActionTypes.SET_SUBSCRIPTION_DATA, {});
      this.$store.dispatch(
        UserActionTypes.SET_UNASSIGNED_SUBSCRIPTIONUSERS,
        {}
      );
    },
    updateDashboardCard() {
      const companyBucketId =
        this.$route.name === "companies"
          ? this.getCompanyData.companyBucketId
          : null;
      const apiService = new APIService(this.axios);
      if (companyBucketId) {
        apiService
          .getSubLicUsage(companyBucketId)
          .then((res) => {
            this.$store.dispatch(CompanyActionTypes.SET_LIC_USAGE, res.items);
          })
          .catch((error) => {
            if (error.code === "ECONNABORTED")
              this.$store.dispatch(AuthActionTypes.SET_ERROR, true);
          });
      }
    },
  },
  props: {
    sortField: Number,
    sortOrder: Number,
  },
});
</script>
